// extracted by mini-css-extract-plugin
export default {"sourceValueCol":"styles_sourceValueCol__HVMEa"};